<template>
 <div class="rankHead">
    <div class="classSelect">
      <span class="_label">班级：</span><span class="selectActive" @click="selectShow">{{className}}</span>
      <span class="button workbtn1" :class="{active: !timeFlag}" @click="setOneweek">近1周</span>
      <span class="button workbtn2" :class="{active: timeFlag}" @click="setOnemonth">近1个月</span>
      <ul class="selectBox" v-if="selectFlag">
        <li v-for="item in classList" @click="changClassId(item)">
          {{item.className}}
        </li>
      </ul>
    </div>
    <div class="timeBox">
      <span class="_label">时间：</span>
      <el-date-picker v-model="startD" type="date" placeholder="选择日期" value-format="timestamp" 
      :picker-options="pickerOptions1" @change="changedPicker()">
      </el-date-picker>
      至
      <el-date-picker v-model="endD" align="right" type="date" placeholder="选择日期" value-format="timestamp"
        :picker-options="pickerOptions2" @change="changedPicker()">
      </el-date-picker>
      <span @click="getWorkStatistics" class="button">查询</span>
    </div>
    <div class="wechatShare" v-if="shareFlag">
      <!-- {{wechatUrl}}kkkkk -->
      <span>微信分享: </span>
      <el-popover placement="bottom-end" width="210" trigger="hover">
        <div id="qrcode" ref="qrcode"></div>
        <p class="wechatTip">打开微信扫一扫分享学生成绩<br/> 每个家长只能看到自己孩子的成绩</p>
        <i class="iconWechat" slot="reference"></i>
      </el-popover>
    </div>
 </div>
</template>
<script>
import QRCode from 'qrcodejs2'
export default {
  props: ['classList', 'className', 'wechatUrl', 'startDate', 'endDate', 'shareFlag'],
  data() {
    return {
      selectFlag: false,
      timeFlag: true,
      startD: this.startDate,
      endD: this.endDate,
      pickerOptions1: {
        disabledDate(time) {
          let date = new Date()
          let Y = date.getFullYear()
          let M = date.getMonth() + 1
          let yesD = date.getDate()
          let minTime = (Y - 1 )+ '-01-01 00:00:00'
          let maxTime = Y + '-' + M + '-' + (yesD - 1) + ' 00:00:00'
          return time.getTime() > new Date(maxTime) || time.getTime() < new Date(minTime);
        },
      },
      pickerOptions2: {
        disabledDate(time) {
          let date = new Date()
          let Y = date.getFullYear()
          let M = date.getMonth() + 1
          let yesD = date.getDate()
          let maxTime = Y + '-' + M + '-' + (yesD - 1) + ' 00:00:00'
          return time.getTime() > new Date(maxTime)
        },
      },
    };
  },
  components: { 
    QRCode 
  },
  watch: {
    wechatUrl(curVal, oldVal){
      this.startD = this.startDate
      this.endD = this.endDate
       if (this.wechatUrl) {
        document.getElementById("qrcode").innerHTML = ''
      }
      this.qrcode()
    },
    startDate () {
      this.startD = this.startDate
      this.endD = this.endDate
    },
    endDate () {
      this.startD = this.startDate
      this.endD = this.endD
    }
  },
  methods: {
    qrcode () {
      let qrcode = new QRCode("qrcode", {
        width: 170,
        height: 170,
      })
      qrcode.makeCode(this.wechatUrl)
    },
    setOnemonth () {
      let nowdate = new Date()
      let y = nowdate.getFullYear();
      let m = nowdate.getMonth();
      let d = nowdate.getDate();
      let formatwdate = y + '-' + m + '-' + (d - 1) + ' 23:59:59';
      let maxTime = y + '-' + (m + 1) + '-' + (d- 1) + ' 23:59:59'
      this.timeFlag = true
      let endDate = Date.parse(maxTime)
      let startDate = Date.parse(formatwdate)
       let data = {
        startDate: startDate,
        endDate: endDate
      }
      this.$emit('changedPicker', data)
    },
    selectShow() {
      this.selectFlag = true
    },
    changedPicker () {
      let data = {
        startDate: this.startD,
        endDate: this.endD
      }
      this.$emit('changedPicker', data)
    },
    changClassId(data) {
      this.selectFlag = false
      this.$emit("changClassId", data);
    },
    setOneweek () {
        let nowdate = new Date()
        let y = nowdate.getFullYear();
        let m = nowdate.getMonth();
        let d = nowdate.getDate();
        let maxTime = y + '-' + (m + 1) + '-' + (d - 1) + ' 23:59:59'
        this.timeFlag = false
        let endDate = Date.parse(maxTime)
        let startDate = Date.parse(maxTime) - 7 * 3600 * 24 * 1000
        let data = {
          startDate: startDate,
          endDate: endDate
       }
      this.$emit('changedPicker', data)
    },
    getWorkStatistics () {
      // if (this.wechatUrl) {
      //   document.getElementById("qrcode").innerHTML = ''
      // }
      // this.qrcode()
      this.$emit('getWorkStatistics')
    }
  }
};
</script>



// WEBPACK FOOTER //
// header.vue?7ace5905